import React from 'react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import logo from '../../assets/logo.png'

const LoadingScreen = () => {
  const { t } = useTranslation()
  const brandWordmarkClass = "font-['Orbitron'] font-black italic uppercase leading-none text-white drop-shadow-[0_2px_0_rgba(11,18,32,0.9)]"
  const brandWordmarkStyle = {
    WebkitTextStroke: '1px rgba(13, 27, 55, 0.9)',
    textShadow: '0 2px 0 rgba(13,27,55,0.95), 0 0 16px rgba(161, 232, 255, 0.25)'
  }

  return (
    <div className="fixed inset-0 z-50 overflow-hidden bg-sport-darker flex items-center justify-center">
      <div className="absolute inset-0 pointer-events-none opacity-25 [background-image:linear-gradient(rgba(0,212,255,0.15)_1px,transparent_1px),linear-gradient(90deg,rgba(0,212,255,0.15)_1px,transparent_1px)] [background-size:32px_32px]" />
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_50%_20%,rgba(0,212,255,0.22),transparent_42%),radial-gradient(circle_at_50%_90%,rgba(255,0,160,0.18),transparent_35%)]" />
      <motion.div
        className="absolute left-0 right-0 top-0 h-[2px] bg-gradient-to-r from-transparent via-sport-primary to-transparent"
        animate={{ y: ['0vh', '100vh'] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: 'linear' }}
      />

      <div className="relative text-center px-6 w-full max-w-xl">
        <motion.div
          animate={{ scale: [0.98, 1.05, 0.98] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
          className="relative mx-auto mb-6 h-40 w-40 md:h-48 md:w-48"
        >
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 7, repeat: Infinity, ease: 'linear' }}
            className="absolute inset-0 rounded-full border border-sport-primary/40"
          />
          <motion.div
            animate={{ rotate: -360 }}
            transition={{ duration: 10, repeat: Infinity, ease: 'linear' }}
            className="absolute inset-3 rounded-full border border-dashed border-sport-secondary/50"
          />
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-sport-primary/30 to-sport-secondary/30 blur-2xl" />
          <div className="relative h-full w-full rounded-full bg-sport-dark/85 border border-sport-silver/20 backdrop-blur-xl flex items-center justify-center">
            <img
              src={logo}
              alt={t('app.brand')}
              className="h-24 w-24 md:h-32 md:w-32 object-contain drop-shadow-2xl"
            />
          </div>
        </motion.div>

        <motion.h2
          animate={{ opacity: [0.65, 1, 0.65] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
          className={`${brandWordmarkClass} -skew-x-6 text-2xl md:text-4xl tracking-[0.12em] md:tracking-[0.16em]`}
          style={brandWordmarkStyle}
        >
          {t('app.brand').toUpperCase()}
        </motion.h2>

        <p className="mt-2 text-sport-silver/80 text-xs md:text-sm uppercase tracking-[0.24em]">
          {t('loading.initializingMatchArena')}
        </p>

        <div className="mt-7">
          <div className="h-3 w-full rounded-full border border-sport-primary/40 bg-sport-dark/70 overflow-hidden">
            <motion.div
              className="h-full rounded-full bg-gradient-to-r from-sport-primary via-sport-silver to-sport-secondary"
              animate={{ x: ['-100%', '100%'] }}
              transition={{ duration: 1.4, repeat: Infinity, ease: 'linear' }}
            />
          </div>
          <div className="mt-2 flex items-center justify-between text-[11px] uppercase tracking-[0.2em] text-sport-light/70">
            <span>{t('loading.sync')}</span>
            <motion.span
              animate={{ opacity: [0.4, 1, 0.4] }}
              transition={{ duration: 1, repeat: Infinity }}
            >
              {t('loading.loadingAssets')}
            </motion.span>
            <span>{t('loading.ready')}</span>
          </div>
        </div>

        <div className="mt-5 flex items-center justify-center gap-2">
          {[0, 1, 2, 3].map((index) => (
            <motion.span
              key={index}
              className="h-1.5 w-8 rounded-full bg-gradient-to-r from-sport-primary to-sport-secondary"
              animate={{ opacity: [0.25, 1, 0.25], scaleX: [0.75, 1.1, 0.75] }}
              transition={{ duration: 1.1, repeat: Infinity, delay: index * 0.15 }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default LoadingScreen